<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Aktive Benutzer</h4>
            <p class="category">Pro Spieltag</p>
          </div>
          <div class="card-content">
            <div id="chartStock" class="ct-chart"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Neue Benutzer</h4>
            <p class="category">Pro Tag</p>
          </div>
          <div class="card-content">
            <div id="chartNewUsers" class="ct-chart"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BetgameStatistics',
    methods: {
      initStockChart () {
        var l = []
        var s = []
        for (let j in this.$store.state.userStatistics) {
          let i = this.$store.state.userStatistics[j]
          l.push('' + i.matchday)
          s.push('' + i.aktive_users)
        }
        const dataStock = {
          labels: l,
          series: [
            s
          ]
        }
        const optionsStock = {
          lineSmooth: false,
          axisY: {
            offset: 40,
            labelInterpolationFnc (value) {
              return `${value}`
            }

          },
          height: '250px'
        }
        this.$Chartist.Line('#chartStock', dataStock, optionsStock)
      },
      initRegistrationsByDate () {
        var l = []
        var s = []
        for (let j in this.$store.state.registrationsByDate) {
          let i = this.$store.state.registrationsByDate[j]
          l.push(i.date)
          s.push('' + i.count)
        }
        const dataStock = {
          labels: l,
          series: [
            s
          ]
        }
        const optionsStock = {
          showPoint: true,
          lineSmooth: false,
          axisY: {
            offset: 40,
            labelInterpolationFnc (value) {
              return `${value}`
            }
          },
          axisX: {
            showGrid: false,
            showLabel: true
          },
          height: '250px'
        }
        this.$Chartist.Bar('#chartNewUsers', dataStock, optionsStock)
        // this.$Chartist.AutoScaleAxis()
      }
    },
    async mounted () {
      const Chartist = await import('chartist')
      this.$Chartist = Chartist
      this.$store.dispatch('fetchUserStatistics', this.$store.state.betgame).then(response => {
        this.initStockChart()
      })
      this.$store.dispatch('fetchRegistrationsByDate', this.$store.state.betgame).then(response => {
        this.initRegistrationsByDate()
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BetgameStatistics.vue